const isBrowserEnvironment = !!navigator;
const rawLang = isBrowserEnvironment ? navigator.language.split("-")[0] : "en";

export const DEFAULT_LANG =
  rawLang === "sv" || rawLang === "nl" ? rawLang.toUpperCase() : "EN";
